import React, { useState } from "react";
import MiloApplication from "../components/MiloApplication";
import TraditionalDemo from "../components/TraditionalDemo";
import RedSquare from "../components/RedSquare"; 
import styles from "../styles/Demo.module.css";


const Demo = () => {
  const [activeTab, setActiveTab] = useState("milo");
  const [menuOpen, setMenuOpen] = useState(true); // Tracks collapse/expand state
  const [miloState, setMiloState] = useState(0);
  const [traditionalState, setTraditionalState] = useState(1);

  return (
	<div className={styles["demo-wrapper"]}>
		{window.innerWidth > 768 && (
			<>
				{/*<button className={styles["collapse-btn"]} onClick={() => setMenuOpen(!menuOpen)}>
				  {menuOpen ? "◀ Hide Menu" : "▶ Show Menu"}
				</button>*/}
				<div className={`${styles["demo-container"]} ${menuOpen ? styles.expanded : styles.collapsed}`}>
					{menuOpen && (
					  <>
						<h2>Compare the Renting Experience</h2>
						<p>See how MILO compares to traditional renting.</p>

						<div className={styles["demo-tabs"]}>
						  <button 
							className={`${styles.tab} ${activeTab === "milo" ? styles.active : styles.inactive}`} 
							onClick={() => setActiveTab("milo")}
						  >
							🚀 MILO Process
						  </button>
						  <button 
							className={`${styles.tab} ${activeTab === "traditional" ? styles.active : styles.inactive}`} 
							onClick={() => setActiveTab("traditional")}
						  >
							🏠 Traditional Renting
						  </button>
						</div>
					  </>
					)}
			  </div>
		  </>
	  )}


	   <div className={styles["demo-content"]}>
        {activeTab === "milo" ? <MiloApplication step={miloState} setStep={setMiloState} /> : <TraditionalDemo step={traditionalState} setStep={setTraditionalState} />}
      </div>
	  
	  {window.innerWidth <= 768 && (
		   <div className={styles["mobile-nav"]}>
				<button 
				  className={`${styles.tab} ${activeTab === "milo" ? styles.active : styles.inactive}`} 
				  onClick={() => setActiveTab("milo")}
				>
				  🚀 MILO
				</button>
				<button 
				  className={`${styles.tab} ${activeTab === "traditional" ? styles.active : styles.inactive}`} 
				  onClick={() => setActiveTab("traditional")}
				>
				  🏠 Traditional
				</button>
		  </div>
	  )}
    </div>
  );
};

export default Demo;
